// extracted by mini-css-extract-plugin
export default {"tagWrapper":"TagList_tagWrapper__tIbx8","tag":"TagList_tag__mFFQK"};